import { api } from '@/lib/axios';
import { LoginDto, LoginResponse, User } from '@caruso/types';

export const authService = {
  async login(data: LoginDto): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', data);
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  async getProfile(): Promise<User> {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  async refresh(): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/refresh');
    return response.data;
  },
};